import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';
import Disclaimer from './Disclaimer';

const schema: JSONSchema7 = {
    title: 'Disclaimer',
    type: 'object',
    required: [],
    properties: {
        styles: {
            type: 'string',
            description: 'A stylesheet',
            default: '',
        },
        annotationDataKey: {
            type: 'string',
            title: 'Annotations Data',
            default: 'annotations',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
    },
    dependencies: {
        ...customSchemas.layoutSchema.LayoutSchema.dependencies,
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: ['annotationDataKey'],
    },
];

const uiSchema = {
    'ui:groups': groups,
    ...customSchemas.textSchema.TextSchema.uiSchema,
    ...customSchemas.styleSchema.StyleSchema.uiSchema,
    ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
    annotationDataKey: {
        'ui:placeholder': 'Enter annotation data property',
    },
    styles: {
        'ui:widget': 'CSSEditor',
    },
};

const DisclaimerWidget: commonTypes.IWidget = {
    schema,
    uiSchema,
    templateView: Disclaimer,
    id: 'Disclaimer',
    group: 'component',
    contentPlaceHolders: ['children'],
    initialData: () => ({}),
};

export default DisclaimerWidget;
